export default __webpack_public_path__ + "static/media/baza.688c93d9.gif";